import { GET_VERSOES_PBI_INIT, GET_VERSOES_PBI_SUCCESS, UPDATE_STATUS_VERSAO_PBI_INIT, UPDATE_STATUS_VERSAO_PBI_SUCCESS, ERROR_DEFINICOES_PBI_MSG, CLEAR_FLAGS_DEFINICOES_PBI } from '../actionTypes';
import { IVersaoPbi } from 'src/integracoes/servicos/mongo-atlas/modelos/IDefinicoesPbi';

export const getVersoesPbiInit = () => ({
  type: GET_VERSOES_PBI_INIT
});

export const getVersoesPbiSuccess = (data: { versoesPbi: IVersaoPbi[] }) => ({
  type: GET_VERSOES_PBI_SUCCESS,
  payload: data
});

export const updateStatusVersaoPbiInit = (data: { versao: string; statusVersao: string }) => ({
  type: UPDATE_STATUS_VERSAO_PBI_INIT,
  payload: data
});

export const updateStatusVersaoPbiSuccess = (data: { versao: string; statusVersao: string }) => ({
  type: UPDATE_STATUS_VERSAO_PBI_SUCCESS,
  payload: data
});

export const errorDefinicoesPbiMsg = (data: any) => ({
  type: ERROR_DEFINICOES_PBI_MSG,
  payload: data
});

export const clearFlagsDefinicoesPbi = () => ({
  type: CLEAR_FLAGS_DEFINICOES_PBI
});
